import { User } from '@datadog/browser-core';
import { datadogLogs } from '@datadog/browser-logs';

const urlMatchers = [
  'chrome-extension://npciikilfcggljgdkebakdcccmkdmpik',
  'https://api.segment.io',
  'https://cdn.segment.com',
  'safari-extension://',
];

const ignoredNetworkErrorUrls = [
  'cloudflareinsights.com',
  '/cdn-cgi/rum', // Cloudflare Web Analytics, incl. proxied through our own zones
  'api.segment.io',
  'cdn.segment.com',
  'google-analytics.com',
];

const errorMatchers = [
  'Empty reason',
  'Load failed',
  'Script error.',
  'Failed to fetch',
  "this.errorCb is not a function. (In 'this.errorCb(y)', 'this.errorCb' is null)",
  "null is not an object (evaluating 'this._map.removeLayer')",
  "undefined is not an object (evaluating 'E._leaflet_pos')",
  'ResizeObserver loop limit exceeded',
  "TypeError: Cannot read properties of null (reading 'removeLayer')",
  'can\'t access property "removeLayer", this._map is null',
  'Error sending segment performance metrics', // Segment error
  'Failed to load Analytics.js', // Segment error
  'Fetch error GET chrome-extension://npciikilfcggljgdkebakdcccmkdmpik/icons/logo.png', // Chrome extension error
  '_leaflet_pos', //Leaflet error
  'Unauthorized', //Loadboard webview error
  'gmo', //Google Search error https://issuetracker.google.com/issues/396043331?pli=1
  'ArrayBuffer at index', // mapbox-gl worker race condition https://github.com/mapbox/mapbox-gl-js/issues/9019
];

const errorKindMatchers = ['APIError', 'MapboxError'];

const ignoreStackPatterns = ['chrome-extension://'];

function getService() {
  switch (import.meta.env.VITE_APP_NAME) {
    case 'ctms':
      return 'carrier-tms-web';
    case 'slbd':
      return 'loadboard-web';
    case 'slbm':
      return 'loadboard-webview';

    case 'ctmsw':
      return 'carrier-tms-webview';
  }
}

export function init() {
  datadogLogs.init({
    clientToken: 'pubf1b3fd8bf6ce2148e6ce7eb8a7c80b3a',
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: import.meta.env.VITE_APP_RELEASE,
    env: import.meta.env.VITE_APP_TARGET,
    service: getService(),
    forwardConsoleLogs: ['error'],
    beforeSend(log) {
      if (log.http?.status_code === 0) {
        for (const urlPart of ignoredNetworkErrorUrls) {
          if (log.http.url.includes(urlPart)) {
            return false;
          }
        }

        log.status = 'warn';
        return true;
      }

      if (log.origin === 'console') {
        log.status = 'warn';
        return true;
      }

      //downgrade third-party errors to warn
      if (log.error?.stack?.includes('<anonymous>')) {
        log.status = 'warn';
        return true;
      }

      //downgrade loading errors of specific URLs to warn
      if (log.http) {
        for (const urlPart of urlMatchers) {
          if (log.http.url.startsWith(urlPart)) {
            log.status = 'warn';
            return true;
          }
        }
      }

      //downgrade specific kinds of errors to warn
      if (log.error) {
        for (const pattern of ignoreStackPatterns) {
          if (log.error.stack?.includes(pattern)) {
            return false;
          }
        }

        for (const matcher of errorKindMatchers) {
          if (log.error.kind === matcher) {
            log.status = 'warn';
            return true;
          }
        }
      }

      for (const matcher of errorMatchers) {
        if (log.message.includes(matcher)) {
          log.status = 'warn';
          return true;
        }
      }

      return true;
    },
  });
}

export function getLogger() {
  return datadogLogs.logger;
}

export function identifyUser(user: User) {
  datadogLogs.setUser(user);
}

export function clearUser() {
  datadogLogs.clearUser();
}
